import { call, put, takeLatest } from "redux-saga/effects";
import { presetsAPI } from "../api/api";
import { PresetsActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";
import { LEVELS_NAMES } from "../components/PresetConfiguration/PresetConfiguration.component";
import { ToasterService } from "../../../services/toaster/toaster.service";

function* addPreset(action) {
    try {
        const response = yield call(() =>
            presetsAPI.addPreset(
                composePrizeJson(action.payload.game_specific_settings, action.payload.prizes, action.payload.base, action.payload.notes)
            )
        );

        yield put({
            type: PresetsActionTypes.ADD_PRESET_SUCCESS,
            payload: response.data
        });
    } catch (e) {
        API.handleError(e.response, "Error Adding Preset");

        yield put({
            type: PresetsActionTypes.ADD_PRESET_FAIL,
            payload: e
        });
    }
}

export function* addPresetWatcher() {
    yield takeLatest(PresetsActionTypes.ADD_PRESET, addPreset);
}

function* editPreset(action) {
    try {
        const response = yield call(() =>
            presetsAPI.editPreset(
                action.payload.presetId,
                {notes: composePrizeJson(action.payload.game_specific_settings, action.payload.prizes, action.payload.base, action.payload.notes).notes} //apenas vamos permitir editar o campo notes
            )
        );

        ToasterService.successToast("Preset edited with success.");

        yield put({
            type: PresetsActionTypes.EDIT_PRESET_SUCCESS,
            payload: response.data
        });
    } catch (e) {
        API.handleError(e.response, "Error Editing Preset");

        yield put({
            type: PresetsActionTypes.EDIT_PRESET_FAIL,
            payload: e
        });
    }
}

export function* editPresetWatcher() {
    yield takeLatest(PresetsActionTypes.EDIT_PRESET, editPreset);
}

function* togglePresetActiveState(action) {
    const presetId = action.payload.presetId;
    const active = action.payload.active;
    try {
        let status = undefined;
        if (active) {
            status = yield call(() => presetsAPI.activatePreset(presetId));
        } else {
            status = yield call(() => presetsAPI.deactivatePreset(presetId));
        }

        if (status.status == 200) {
            yield put({
                type: PresetsActionTypes.TOGGLE_PRESET_ACTIVE_SUCCESS,
                payload: {
                    active: active,
                    presetId: presetId
                }
            });
        } else {
            ToasterService.errorToast("Error changing preset status.");
        }
    } catch (e) {
        API.handleError(e.response, "Error changing preset status.");

        yield put({
            type: PresetsActionTypes.TOGGLE_PRESET_ACTIVE_FAIL,
            message: e.message
        });
    }
}

export function* togglePresetActiveStateWatcher() {
    yield takeLatest(
        PresetsActionTypes.TOGGLE_PRESET_ACTIVE,
        togglePresetActiveState
    );
}

function* toggleCertifiedPreset(action) {
    const presetId = action.payload.presetId;
    const certified = action.payload.certified;
    try {
        let status = yield call(() => presetsAPI.certifiedPreset(presetId, certified));

        if (status.status == 200) {
            yield put({
                type: PresetsActionTypes.TOGGLE_CERTIFIED_PRESET_SUCCESS,
                payload: {
                    certified: certified,
                    presetId: presetId
                }
            });
        } else {
            ToasterService.errorToast("Error in certifying preset.");
        }
    } catch (e) {
        API.handleError(e.response, "Error in certifying preset.");

        yield put({
            type: PresetsActionTypes.TOGGLE_CERTIFIED_PRESET_FAIL,
            message: e.message
        });
    }
}

export function* toggleCertifiedPresetWatcher() {
    yield takeLatest(
        PresetsActionTypes.TOGGLE_CERTIFIED_PRESET,
        toggleCertifiedPreset
    );
}

const composePrizeJson = (game_specific_settings, prizes, base, notes) => {
    let jsonPrizes = [];

    const convertibleFields = [
        "contribution",
        "max_value",
        "increment_sound_value",
        "initial_value"
    ];

    Object.keys(LEVELS_NAMES).map(level => {
        const levelKeys = Object.keys(prizes).filter(prizeKey => {
            return prizeKey.startsWith(`${level}_`);
        });

        if (levelKeys.length > 0) {
            let newPrize = {};
            newPrize["level"] = parseInt(level);
            levelKeys.map(key => {
                newPrize[key.substring(2)] = convertibleFields.includes(
                    key.substring(2)
                )
                    ? parseInt(String(prizes[key] * 100))
                    : prizes[key];
            });
            newPrize["max_bet"] = 1;
            newPrize["min_bet"] = 1;
            jsonPrizes.push(newPrize);
        }
    });

    jsonPrizes.map(p=>
        p.fractionated_jackpot_list && p.fractionated_jackpot_list.map((f, index)=> {
                Object.keys(f).map((key, index) => {
                    f[key]=f[key] * 100
                    f[key]=parseInt(f[key])
                })
                f.bet = index + 1
            })
    )

    base.settings && Object.keys(base.settings).map((key, index)=>{
        if(convertibleFields.includes(key)){
            base.settings[key]=base.settings[key] * 100
        }
    })
    base.settings.fractionated_jackpot_list && base.settings.fractionated_jackpot_list.map((f, index)=> {
        Object.keys(f).map((key, index) => {
            f[key]=f[key] * 100
            f[key]=parseInt(f[key])
        })
        f.bet = index + 1
    })

    Array.from(Array(5).keys()).map( i => {
        base.settings['frequency_prizes_list'+i] && base.settings['frequency_prizes_list'+i].map((f, index)=> {
            Object.keys(f).map((key, index) => {
                f[key]=parseInt(f[key])
                if(key=='0'){
                    f.bet = f[key]
                    delete f[key]
                }
            })
        })
    })

    game_specific_settings.map(game_specific => {
        Object.keys(game_specific).map((key, index)=>{
            if(convertibleFields.includes(key)){
                game_specific[key] = game_specific[key] * 100
            }
        })
    })

    return {
        ...base,
        prizes: jsonPrizes,
        game_specific_settings,
        notes: notes
    };
};
